export const HFMarkers = [
    { country: "Hugging Face", coordinates: [40.7128, -74.0060] }
];